
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jjVGE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $diswb = parcelRequire("diswb");


var $a4TK8 = parcelRequire("a4TK8");


var $gUoHD = parcelRequire("gUoHD");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $b3j2Y = parcelRequire("b3j2Y");


var $7zgzO = parcelRequire("7zgzO");











var $1kHsc = parcelRequire("1kHsc");


var $eSUdr = parcelRequire("eSUdr");

const $7386727160b552e6$export$bb78098851fd69ee = // eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
(0, $eSUdr.default)`query ArchiveLongTaskStatusExperimental($taskId:ID!)@experimental{experimentalLongTask(taskId:$taskId){id elapsedTime percentageComplete messages{translation}successful}}`;



var $jjVGE = parcelRequire("jjVGE");

const $ee667811cbe727db$var$POLL_INTERVAL_MS = 500; // 0.5 seconds
const $ee667811cbe727db$var$POLL_TIMEOUT_MS = 60000; // 60 seconds
const $ee667811cbe727db$export$9ab705381109ff32 = ({ longTaskId: longTaskId, onError: onError, onStatusUpdate: onStatusUpdate, isArchive: isArchive, pollTimeout: pollTimeout = $ee667811cbe727db$var$POLL_TIMEOUT_MS, isBulk: isBulk, featureName: featureName, processedPageIds: processedPageIds })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, error: error, stopPolling: stopPolling } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
    (0, $7386727160b552e6$export$bb78098851fd69ee), {
        fetchPolicy: 'network-only',
        pollInterval: $ee667811cbe727db$var$POLL_INTERVAL_MS,
        variables: {
            taskId: longTaskId
        }
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const handleError = (0, $42omo.useCallback)((error, pageIds)=>{
        experienceTracker.stopOnError({
            name: (0, $jjVGE.getExperienceName)(isArchive),
            error: error,
            attributes: {
                featureName: featureName
            }
        });
        if (isArchive && isBulk) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'bulkArchive',
                source: featureName,
                attributes: {
                    pageCount: pageIds?.length || processedPageIds.length,
                    errorMessage: error.message
                }
            }
        }).fire();
        onError(error);
        stopPolling();
    }, [
        experienceTracker,
        isArchive,
        isBulk,
        featureName,
        onError,
        stopPolling,
        createAnalyticsEvent,
        processedPageIds.length
    ]);
    (0, $42omo.useEffect)(()=>{
        // stop polling and report error if we've timed out
        const timeout = setTimeout(()=>{
            handleError(new Error('Timed out while polling server for status of page archival process'));
        }, pollTimeout);
        // clean up on unmount
        return ()=>clearTimeout(timeout);
    }, [
        handleError,
        pollTimeout
    ]);
    // The callback (prop) functions that affect the parent component's state cannot be called during
    // the rendering process, and instead must be in a "useEffect()" hook, which are called after the
    // rendering has completed.
    // Query error processing:
    (0, $42omo.useEffect)(()=>{
        error && handleError(error);
    }, [
        error,
        handleError
    ]);
    // onStatusUpdate callback processing:
    (0, $42omo.useEffect)(()=>{
        const longTask = data && data.experimentalLongTask || null;
        if (longTask) {
            const percentageComplete = longTask.percentageComplete || 0;
            const { successful: successful } = longTask;
            let pageIds = [];
            let pageIdProcessingError = null;
            // The longtask API doesn't allow custom formatted data to be returned
            // yet, so for now the only way to pass/retrieve the IDs of the pages that
            // have been successfully archived is via the messages field. We have to
            // parse the text for the comma-delimited array of page IDs in a string
            // that looks like this:
            // "PageArchivedList :: [123,345,456]"
            // "PageUnArchivedList :: [123,345,456]"
            // TODO: better way to receive pageIds is using args instead of translation string.
            // regex to match list type label
            const listTypeRegex = new RegExp(`^(PageUnArchivedList|PageArchivedList)`, 'gi');
            // regex to match pageIds
            const pageIdRegex = new RegExp(`([\\d*]+)`, 'g');
            try {
                const { messages: messages } = longTask;
                for(let i = messages.length - 1; i >= 0; --i){
                    const { translation: translation } = messages[i];
                    const listType = translation.match(listTypeRegex);
                    if (!listType) break;
                    const pageIdArray = translation.match(pageIdRegex);
                    if (pageIdArray && pageIdArray.length) {
                        // able to parse pageIds so break
                        pageIds = pageIdArray;
                        break;
                    }
                }
            } catch (e) {
                // backend did not send data in the expected format
                pageIdProcessingError = e;
            }
            // If no errors have occured, report the status
            if (!pageIdProcessingError) {
                // If everything has completed, stop polling
                if (successful && percentageComplete === 100) stopPolling();
                onStatusUpdate({
                    archivingSuccessPages: pageIds,
                    percentageComplete: percentageComplete
                });
            } else handleError(pageIdProcessingError, pageIds);
        }
    }, [
        data,
        handleError,
        onStatusUpdate,
        stopPolling
    ]);
    // Regular rendering:
    return null;
};


/**
 * @graphql cc
 */ 











const $160c5e586cb409ac$var$TOOLS_MENU_LOCATION = 'system.content.action';
function $160c5e586cb409ac$export$9bc52d03b097c5e3({ contentId: contentId, processedPageIds: processedPageIds }) {
    const { error: error } = (0, $diswb.useQuery)((0, $eSUdr.default)`query ArchiveProcessSuccessQuery($contentId:ID!$processedPageIds:[ID]!$webItemLocation:String!$navigationType:String){content(ids:$processedPageIds status:["archived" "current"]navigationType:$navigationType){nodes{id type operations{operation targetType}status type ancestors{id type title status}}}singleContent(id:$contentId){id children{count nodes{id status}}hasVisibleChildPages}webItemSections(location:$webItemLocation contentId:$contentId){id label styleClass cacheKey items{accessKey completeKey hasCondition id icon{path}params{key value}label moduleKey section styleClass tooltip url urlWithoutContextPath weight}}}`, {
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
        variables: {
            contentId: contentId,
            processedPageIds: processedPageIds,
            webItemLocation: $160c5e586cb409ac$var$TOOLS_MENU_LOCATION,
            navigationType: 'contentTree'
        }
    });
    return error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null;
}


/* ArchiveFlags.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $iKCFj = parcelRequire("iKCFj");





var $gtD4K = parcelRequire("gtD4K");


var $T1bCI = parcelRequire("T1bCI");


var $6UBEn = parcelRequire("6UBEn");





var $67Foi = parcelRequire("67Foi");


var $cqmCC = parcelRequire("cqmCC");


var $gqqjz = parcelRequire("gqqjz");





var $1NBp8 = parcelRequire("1NBp8");


var $12UWa = parcelRequire("12UWa");


var $aqBZ0 = parcelRequire("aqBZ0");


var $hCblD = parcelRequire("hCblD");

const $55190ab9633568b4$var$ProgressBarContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _4t3izwfg _1bah1h6o _u5f31jfw",
            __cmplp.className
        ])
    });
});
const $55190ab9633568b4$var$getTitle = (flagI18n, currentArchiveStatus, contentIds)=>{
    const TitleMap = {
        [(0, $aqBZ0.ArchiveStatus).LOADING]: flagI18n.loadingTitle,
        [(0, $aqBZ0.ArchiveStatus).ERROR]: flagI18n.errorTitle,
        [(0, $aqBZ0.ArchiveStatus).SUCCESS]: flagI18n.successTitle
    };
    const titleDescriptor = TitleMap[currentArchiveStatus];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...titleDescriptor,
        values: {
            count: contentIds.length
        }
    });
};
const $55190ab9633568b4$export$fb27254ebda7034 = ({ contentIds: contentIds, error: error, flagI18n: flagI18n, isArchive: isArchive, isIndeterminate: isIndeterminate, percentageComplete: percentageComplete, successLinkHref: successLinkHref, onSuccessLinkClick: onSuccessLinkClick, isBulk: isBulk, shouldUseAutomationDiscovery: shouldUseAutomationDiscovery })=>{
    const [lastPercentageComplete, setLastPercentageComplete] = (0, $42omo.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [lastError, setLastError] = (0, $42omo.useState)(null);
    const flagIdRef = (0, $42omo.useRef)(undefined);
    const success = !error && percentageComplete === 100;
    const { getHref: getHref, matchRoute: matchRoute } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const route = matchRoute(getHref());
    const intlPrefix = `${isArchive ? (0, $aqBZ0.ARCHIVE_INTL_PREFIX) : (0, $aqBZ0.UNARCHIVE_INTL_PREFIX)}${success ? 'archiveContentFlagSuccess' : error ? 'archiveContentFlagFailure' : 'archiveContentFlagProgress'}`;
    const actionName = (0, $12UWa.getActionName)(isArchive);
    const archiveStatus = error && (0, $aqBZ0.ArchiveStatus).ERROR || success && (0, $aqBZ0.ArchiveStatus).SUCCESS || (0, $aqBZ0.ArchiveStatus).LOADING;
    const flagName = error && 'Error' || success && 'Success' || 'Loading';
    const sourceName = `${actionName}Pages${flagName}Flag`; // Note the firing of the Screen event (aka, the <ScreenEvent> component) may need to be changed
    // to manually fire the event in a useEffect hook when progress bar updates are implemented, as
    // the title may end up getting rendered multiple times and the Screen event would be fired more
    // than once.  Also, "id" is a required prop for <ScreenEvent>, but is not actually sent in the
    // event
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
        name: sourceName,
        id: ""
    }), $55190ab9633568b4$var$getTitle(flagI18n, archiveStatus, contentIds));
    const getDescription = (flagI18n, currentArchiveStatus, percentageComplete, error)=>{
        switch(currentArchiveStatus){
            case (0, $aqBZ0.ArchiveStatus).ERROR:
                {
                    const errorMsg = flagI18n.getErrorMessage(error);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                        ...errorMsg,
                        values: {
                            tryLater: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $hCblD.i18n).tryLater)),
                            lineBreak: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null),
                            supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cqmCC.AtlassianSupportLink), null)
                        }
                    });
                }
            case (0, $aqBZ0.ArchiveStatus).LOADING:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($55190ab9633568b4$var$ProgressBarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UBEn.default), {
                    ariaLabel: `Done: ${percentageComplete}% completed`,
                    isIndeterminate: isIndeterminate,
                    value: percentageComplete / 100
                }));
            case (0, $aqBZ0.ArchiveStatus).SUCCESS:
                return '';
        }
    };
    const handleSuccessLinkClick = (0, $42omo.useCallback)(()=>{
        (0, $12UWa.fireUIClickEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            actionSubject: 'link',
            // actionSubjectId should be either "viewArchivedPage" or "viewRestoredPage" but
            // actionName is either "archive" or "restore"
            actionSubjectId: `view${(0, (/*@__PURE__*/$parcel$interopDefault($iKCFj)))(actionName)}dPage`,
            source: sourceName
        });
        onSuccessLinkClick && onSuccessLinkClick();
    }, [
        actionName,
        sourceName,
        createAnalyticsEvent,
        onSuccessLinkClick
    ]);
    const successActions = (0, $42omo.useMemo)(()=>{
        const actions = [];
        if (route?.name !== (0, $1NBp8.SPACE_ARCHIVED_PAGES).name && success) {
            actions.push({
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $hCblD.i18n)[`${intlPrefix}_LinkText`]),
                href: successLinkHref,
                onClick: handleSuccessLinkClick
            });
            if (isBulk) actions.push({
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $hCblD.i18n).refresh_LinkText),
                href: '',
                onClick: ()=>window.location.reload()
            });
        }
        return actions;
    }, [
        success,
        isBulk,
        handleSuccessLinkClick,
        intlPrefix,
        successLinkHref,
        route
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>{
        if (// If we're using automation discovery, only show error flags
        // since the archive modal will show a success message
        // This avoids a situation where both the modal and flag show a success message
        // error !== lastError is required to prevent a render loop. See note at the end of this block
        shouldUseAutomationDiscovery ? flagName === 'Error' && !!error !== lastError : // If the state of the archive/restore operation has changed, update the flag's contents
        percentageComplete !== lastPercentageComplete || !!error !== lastError) {
            flags.showFlag({
                id: flagIdRef.current,
                // specifying the ID will update the existing flag
                type: success ? 'success-circle' : !!error ? 'error' : 'info',
                title: title,
                description: getDescription(flagI18n, archiveStatus, percentageComplete, error),
                actions: successActions
            }).then((newFlag)=>{
                // If a new flag was created, store the new flag's ID so we can update it.  Note that
                // `showFlag()` only asynchronously returns a valid newFlag if it created a new flag;
                // if it found an existing flag with the specified ID then it asynchronously returns
                // nothing (undefined).
                if (newFlag) flagIdRef.current = newFlag.id;
            }); // Similar flags rendering issue noted in LinkToThisPageDialog:
            // Set the state to record that the data affecting the flag has been updated.  Without
            // this, we can get into an infinite rerendering loop that causes Chrome to crash.
            // (We only need to check the `error` variable, because React's state comparison thinks
            // two different object instances with the same members and values are different.  We
            // don't need to check primitive values like `percentageComplete` because React correctly
            // compares them.)
            (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(error, lastError) || setLastError(!!error);
            setLastPercentageComplete(percentageComplete);
        }
        return null;
    });
};


/**
 * @graphql cc
 */ 












var $bQm3c = parcelRequire("bQm3c");




function $3bb21fab838fb592$export$b9a06224bbbb8fed({ archivingError: archivingError, archivingPercentageComplete: archivingPercentageComplete, contentIds: contentIds, isArchive: isArchive, isBulk: isBulk, source: source, pageCount: pageCount, spaceId: spaceId, additionalTrackEventAttributes: additionalTrackEventAttributes }) {
    const analyticsFired = (0, $42omo.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { data: data, error: error } = (0, $diswb.useQuery)((0, $eSUdr.default)`query ArchivePagesEndAnalyticsQuery($spaceId:ID){space(id:$spaceId){id homepage{id}currentUser{isAdmin}}}`, {
        variables: {
            spaceId: spaceId
        }
    });
    (0, $42omo.useEffect)(()=>{
        // Don't let an error in getting the space admin data keep us from firing the event
        if (data || error) {
            const isSpaceAdmin = data?.space?.currentUser?.isAdmin || false;
            const actionName = (0, $12UWa.getActionName)(isArchive, isBulk);
            const spaceOverviewId = data?.space?.homepage?.id;
            if (!analyticsFired.current && archivingPercentageComplete === 100 || archivingError) {
                (0, $12UWa.fireTrackEvent)({
                    createAnalyticsEvent: createAnalyticsEvent,
                    action: archivingError ? `${actionName}Failed` : `${actionName}Success`,
                    actionSubject: 'page',
                    actionSubjectId: isBulk ? 'multiple' : contentIds[0],
                    source: source,
                    containerType: 'space',
                    containerId: spaceId,
                    attributes: {
                        pageCount: pageCount,
                        edition: edition,
                        contentId: isBulk ? undefined : contentIds[0],
                        isSpaceOverview: spaceOverviewId && contentIds.includes(spaceOverviewId) ? true : undefined,
                        ...!error && {
                            isSpaceAdmin: isSpaceAdmin
                        },
                        error: archivingError ? archivingError.message : undefined,
                        ...additionalTrackEventAttributes
                    }
                });
                analyticsFired.current = true;
            }
        }
    }, [
        analyticsFired,
        archivingError,
        archivingPercentageComplete,
        contentIds,
        createAnalyticsEvent,
        data,
        error,
        edition,
        isArchive,
        source,
        isBulk,
        pageCount,
        spaceId,
        additionalTrackEventAttributes
    ]);
    return null;
}


/**
 * @graphql cc
 */ 












var $1ggpj = parcelRequire("1ggpj");








var $7xVCs = parcelRequire("7xVCs");





var $4o1RV = parcelRequire("4o1RV");




function $7ba3e52ab49cfc88$export$74cfc6d5db922d0c({ contentId: contentId, pageBeingViewedId: pageBeingViewedId, pageBeingViewedLastStatus: pageBeingViewedLastStatus }) {
    const { getHref: getHref, matchRoute: matchRoute, push: push, setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const route = matchRoute(getHref());
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const { data: data, error: error, loading: loading } = (0, $diswb.useQuery)((0, $eSUdr.default)`query ArchivePagesLoaderSuccessQuery($archivedPageId:ID!$pageBeingViewedId:ID!$hasPageBeingViewedId:Boolean!){singleContent(id:$archivedPageId){ancestors{id status}archivedContentMetadata{restoreParent{id status links{context webui}}}id space{homepage{id}alias id key}status}pageBeingViewed:singleContent(id:$pageBeingViewedId)@include(if:$hasPageBeingViewedId){id status}currentPage:ptpage(id:$archivedPageId pageTree:500 status:[CURRENT]enablePaging:true){id status}}`, {
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
        variables: {
            archivedPageId: contentId,
            pageBeingViewedId: pageBeingViewedId || '',
            hasPageBeingViewedId: Boolean(pageBeingViewedId)
        }
    });
    const [pageTreeContentIdToLoad, setPageTreeContentIdToLoad] = (0, $42omo.useState)(null);
    const [pageTreeUpdateFired, setPageTreeUpdateFired] = (0, $42omo.useState)(false);
    const [isArchiveSuccessProcessComplete, setIsArchiveSuccessProcessComplete] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!loading && !isArchiveSuccessProcessComplete) {
            const archivedPageStatus = data?.singleContent?.status;
            if (archivedPageStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED)) {
                const spaceKey = data?.singleContent?.space?.key;
                const spaceAlias = data?.singleContent?.space?.alias || spaceKey;
                const spaceHomepageId = data?.singleContent?.space?.homepage?.id;
                const restoreParent = data?.singleContent?.archivedContentMetadata?.restoreParent;
                let archivedPageAncestorContentId;
                if (restoreParent && restoreParent.id && restoreParent.status !== (0, $aqBZ0.CONTENT_STATUS_ARCHIVED)) archivedPageAncestorContentId = restoreParent.id;
                /**
         * Always update the page tree state
         *  - If possible, use the closest surviving ancestor
         *  - Next, try the space overview
         *  - If there's no space overview, we use the contentId in order to force the page tree to refresh.
         *    cc-page-tree will return null for this value, not an error.  The result should be an updated
         *    page tree with no page highlighted.
         */ setPageTreeContentIdToLoad(archivedPageAncestorContentId || spaceHomepageId || contentId);
                /**
         * Check if the page being viewed was archived.
         * If it's still current or it was already archived, there's no need to redirect.
         * Examples:
         *  - Archive the page you are viewing
         *     + spage you are viewing status flips from current -> archived
         *     + redirect to parent
         *  - Archive an ancestor of the page you are viewing, and the archive INCLUDES nested pages
         *     + page you are viewing status flips from current -> archived
         *     + redirect to the highest non-archived parent (restoreParent of the page you archived)
         *  - Archive an ancestor of the current page you are viewing, and the archive does NOT include children
         *     + page you are viewing status remains current
         *     + page you are viewing will be re-located in the page tree and you will not be redirected
         *  - Archive a cousin page in the page tree to the page you are viewing
         *     + page you are viewing status remains current and you will not be redirected
         */ if (route?.name && (0, $1ggpj.ARCHIVE_SUCCESS_REDIRECT_ROUTES).includes(route.name)) {
                    const pageBeingViewedNewStatus = data?.pageBeingViewed?.status;
                    if (pageBeingViewedNewStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED) && pageBeingViewedLastStatus !== (0, $aqBZ0.CONTENT_STATUS_ARCHIVED)) {
                        let nextHref;
                        /**
             * If the last surviving ancestor exists and isn't the space overview, redirect to it.
             * Otherwise, always try to redirect to the space index. Either
             *  - The space overview is actually the last surviving ancestor.
             *  - The page being archived is an orphan. If there's no overview then users will see the space
             *    overview's empty state.
             */ if (archivedPageAncestorContentId && archivedPageAncestorContentId !== spaceHomepageId && restoreParent?.links?.context && restoreParent?.links?.webui) nextHref = restoreParent.links.context + restoreParent.links.webui;
                        else nextHref = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
                            spaceKey: spaceAlias
                        }, {
                            query: spaceHomepageId ? {
                                [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: spaceHomepageId
                            } : undefined
                        });
                        if (nextHref && nextHref !== getHref()) // For Confluence routePolicy will be undefined, hence we can proceed with re-direction==push.
                        // For Embedded Pages, since routePolicy will be defined, we will not push as Parent Product
                        // will handle the navigation.
                        {
                            if (!routePolicy) push(nextHref);
                        }
                    }
                }
                if (route?.name === (0, $1NBp8.SPACE_ARCHIVED_PAGES).name) // TODO: CCCAXP-595 - This may not do anything; investigate and remove!
                setQueryParams({
                    reload: true
                });
                setIsArchiveSuccessProcessComplete(true);
            }
        }
    }, [
        data,
        loading,
        route,
        getHref,
        push,
        contentId,
        routePolicy,
        setPageTreeContentIdToLoad,
        pageBeingViewedLastStatus,
        isArchiveSuccessProcessComplete,
        setIsArchiveSuccessProcessComplete,
        setQueryParams
    ]);
    return error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $7xVCs.PageTreeStateUpdater)
        ]
    }, (pageStateUpdater)=>{
        if (!pageTreeUpdateFired && pageTreeContentIdToLoad) {
            // only request the page tree update once
            pageStateUpdater.setForceFetchPageId(pageTreeContentIdToLoad);
            setPageTreeUpdateFired(true);
        }
        return null;
    });
}











const $d80001cf274584e7$export$3fc6258832efac22 = ({ contentId: contentId })=>{
    const [pageTreeUpdated, setPageTreeUpdated] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $7xVCs.PageTreeStateUpdater)
        ]
    }, (pageStateUpdater)=>{
        // Make sure we only push the update once
        if (!pageTreeUpdated) {
            // Requests that we fetch the page tree with the newly restored page.
            pageStateUpdater.setForceFetchPageId(contentId);
            // Requests that we highlight the newly restored page in the tree.
            pageStateUpdater.setHighlightPagesIds([
                contentId
            ]);
            setPageTreeUpdated(true);
        }
        return null;
    });
};





const $29a80c47283b956f$export$41aab2a31d24e4dd = (0, $eSUdr.default)`fragment PageStatusFragment on Content{id status}`;


function $09d1033af7cdb9b5$export$4ce0bedef4e84bb7(isArchive) {
    return isArchive ? (0, $irVI7.ARCHIVE_PAGES_EXPERIENCE) : (0, $irVI7.RESTORE_PAGES_EXPERIENCE);
}
const $09d1033af7cdb9b5$export$d761a0b33ff69242 = ({ longTaskId: longTaskId, contentId: contentId, onSuccess: onSuccess, isArchive: isArchive = true, isBulk: isBulk, successLinkHref: successLinkHref, source: source, error: error, onSuccessLinkClick: onSuccessLinkClick, pageCount: pageCount, spaceId: spaceId, additionalTrackEventAttributes: additionalTrackEventAttributes, shouldUseAutomationDiscovery: shouldUseAutomationDiscovery, flagI18n: flagI18n, featureName: featureName })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [processedPageIds, setProcessedPageIds] = (0, $42omo.useState)([]);
    const [percentageComplete, setPercentageComplete] = (0, $42omo.useState)(0);
    const [archivePollStatusError, setArchivePollStatusError] = (0, $42omo.useState)(undefined);
    const { getHref: getHref, matchRoute: matchRoute } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const route = matchRoute(getHref());
    /**
	 * Get the status of the page being viewed BEFORE archiving.
	 * If you're already viewing an archived page, you don't need to be redirected on archive success.
	 */ const pageBeingViewedId = route?.params.contentId || '';
    const [pageBeingViewedLastStatus, setPageBeingViewedLastStatus] = (0, $42omo.useState)('');
    const client = (0, $diswb.useApolloClient)();
    (0, $42omo.useEffect)(()=>{
        if (!pageBeingViewedLastStatus && pageBeingViewedId) try {
            const pageBeingViewedFragment = client.readFragment({
                id: `Content:${pageBeingViewedId}`,
                fragment: (0, $29a80c47283b956f$export$41aab2a31d24e4dd)
            });
            setPageBeingViewedLastStatus(pageBeingViewedFragment?.status || '');
        } catch (e) {}
    }, [
        client,
        pageBeingViewedId,
        pageBeingViewedLastStatus,
        setPageBeingViewedLastStatus
    ]);
    const handleStatusUpdate = (0, $42omo.useCallback)((pollStatusUpdate)=>{
        const updatedPageIds = (0, (/*@__PURE__*/$parcel$interopDefault($gUoHD)))(pollStatusUpdate.archivingSuccessPages);
        const updatedPercentageComplete = pollStatusUpdate.percentageComplete;
        // (Only set the pageIds if they have changed, as React's state comparison thinks two
        // different object instances with the same members and values are different, and causes an
        // infinite rendering loop. Note we don't need to check primitive values like
        // `percentageComplete` because React correctly compares them.)
        (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(processedPageIds, updatedPageIds) || setProcessedPageIds(updatedPageIds);
        setPercentageComplete(updatedPercentageComplete);
        // only call onSuccess if percent complete is 100.
        if (updatedPercentageComplete === 100 && onSuccess) {
            if (isArchive && isBulk) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'succeeded',
                    actionSubject: 'bulkArchive',
                    source: featureName,
                    attributes: {
                        pageCount: updatedPageIds.length
                    }
                }
            }).fire();
            onSuccess();
        }
    }, [
        onSuccess,
        processedPageIds,
        isArchive,
        isBulk,
        createAnalyticsEvent,
        featureName
    ]);
    const archivingError = error || archivePollStatusError;
    // When archived remotely via archiving suggestion email, BE does not pass in contentIds.
    // And with bulk archiving, since there are multiple contentIds which may or may
    // not have a common ancestor, no single representing contentId is passed into this component.
    // Hence, we may need to derive contentId from processedPageIds. The single ID is somewhat
    // arbitrary at this point, just used for analytics and refreshing a few queries.
    // TODO: Remove once BE provide contentIds in query parameters
    const contentIdOrProcessedId = contentId || processedPageIds[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, archivingError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: archivingError
    }) : percentageComplete === 100 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $160c5e586cb409ac$export$9bc52d03b097c5e3), {
        contentId: contentIdOrProcessedId,
        processedPageIds: processedPageIds
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: $09d1033af7cdb9b5$export$4ce0bedef4e84bb7(isArchive),
        attributes: {
            featureName: featureName
        }
    }), isArchive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ba3e52ab49cfc88$export$74cfc6d5db922d0c), {
        contentId: contentIdOrProcessedId,
        pageBeingViewedId: pageBeingViewedId,
        pageBeingViewedLastStatus: pageBeingViewedLastStatus
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d80001cf274584e7$export$3fc6258832efac22), {
        contentId: contentIdOrProcessedId
    })) : longTaskId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ee667811cbe727db$export$9ab705381109ff32), {
        processedPageIds: processedPageIds,
        longTaskId: longTaskId,
        onError: setArchivePollStatusError,
        onStatusUpdate: handleStatusUpdate,
        isArchive: isArchive,
        isBulk: isBulk,
        featureName: featureName
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $55190ab9633568b4$export$fb27254ebda7034), {
        contentIds: processedPageIds,
        percentageComplete: percentageComplete,
        error: archivingError,
        flagI18n: flagI18n,
        isArchive: isArchive,
        isIndeterminate: true,
        successLinkHref: successLinkHref,
        onSuccessLinkClick: onSuccessLinkClick,
        isBulk: isBulk,
        shouldUseAutomationDiscovery: shouldUseAutomationDiscovery
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3bb21fab838fb592$export$b9a06224bbbb8fed), {
        archivingError: archivingError,
        archivingPercentageComplete: percentageComplete,
        isBulk: isBulk,
        contentIds: isBulk ? processedPageIds : [
            contentIdOrProcessedId
        ],
        isArchive: isArchive,
        source: source,
        pageCount: pageCount,
        spaceId: spaceId,
        additionalTrackEventAttributes: additionalTrackEventAttributes
    }));
};
module.exports["getExperienceName"] = $09d1033af7cdb9b5$export$4ce0bedef4e84bb7;
module.exports["ArchiveProgressReport"] = $09d1033af7cdb9b5$export$d761a0b33ff69242;

});

parcelRegister("3hGsa", function(module, exports) {

var $hCblD = parcelRequire("hCblD");

const $3a04d866c14d1333$export$83728ea2bd792f67 = {
    // ** Archive validator messages:
    // (Generated by the Confluence Backend code here: https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence/browse/confluence-core/confluence/src/java/com/atlassian/confluence/api/impl/service/content/ArchiveValidator.java)
    ALREADY_ARCHIVED: 'Cannot archive pages because some or all pages in the input are already archived.',
    ALREADY_DELETED: 'Cannot archive or update pages because some or all pages in the input are deleted.',
    IS_DRAFT: 'Cannot archive or update pages because some or all pages in the input are drafts.',
    ALREADY_UNARCHIVED_PAGES: "Cannot unarchive pages because some or all pages in the input aren't archived.",
    INVALID_CONTENT_FOR_UPDATE_NOTE: "Invalid arguments, can't edit the archive note of content that is unarchived.",
    // unused, resolves to default error
    MATCHING_PARENTPAGEID: "Invalid arguments, parentPageID can't match its child!",
    INVALID_PARENTPAGEID: 'Invalid arguments, parentPageID does not correspond to an existing page.',
    PERMISSION_CONTENTID: 'User does not have permission to perform archiving operations on ContentID',
    SPACE_MISMATCH: "Invalid arguments. Can't unarchive a page to a different space.",
    // unused, resolves to default error
    INVALID_CONTENT: 'Incorrect arguments. One or more given Content IDs were not valid',
    // ** Mutation error messages:
    // (Generated by the Confluence Backend code here: https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence/browse/confluence-core/confluence/src/java/com/atlassian/confluence/api/impl/service/content/PageArchiveServiceImpl.java)
    BULK_QUEUE_BUSY: 'Could not submit request to SQS queue as another archival operation is already running.',
    ITEMS_WITH_INVALID_UNARCHIVE_PERMISSIONS_SUBMITTED: 'User does not have permission to unarchive hierarchical to parentHierarchical',
    NOT_AUTHORIZED_TO_ARCHIVE: 'User not authorized to archive pageID',
    NOT_AUTHORIZED_TO_UNARCHIVE_TO_PARENT: 'User not authorized to unarchive pages to parentPageID',
    NOT_AUTHORIZED_TO_UNARCHIVE: 'User not authorized to unarchive pageID',
    NOT_AUTHORIZED_TO_EDIT_NOTE: 'User not authorized to edit archive note of Content ID',
    // unused, resolves to default error
    // (other mutation errors are things that should never happen and thus probably aren't correctable by the user)
    // ** Long Task error messages:
    // (Generated by the Confluence Backend code here: https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence/browse/confluence-core/confluence/src/java/com/atlassian/confluence/api/impl/service/content/PageArchiveServiceImpl.java
    //  and here: https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence/browse/confluence-core/confluence/src/java/com/atlassian/confluence/pages/bulk/archive/DefaultArchiveManager.java)
    // This error can occur if the content item is a draft, archived, or has already been deleted. Note
    // that we will likely change the code soon to support archived pages and drafts
    INVALID_CONTENT_STATUS_ARCHIVED: 'Hierarchical is already archived',
    INVALID_CONTENT_STATUS_DELETED: 'Hierarchical is deleted',
    INVALID_CONTENT_STATUS_DRAFT: 'Hierarchical is a draft',
    // (other long task errors are things that should never happen and thus probably aren't correctable by the user)
    // ** Long Task Timeout error message, generated by the FE code timeout
    LONG_TASK_TIMEOUT: 'Timed out while polling server for status of process'
};
const $3a04d866c14d1333$export$7a5564ff3f97fa60 = ({ error: error, isArchive: isArchive })=>{
    let userMessage = null;
    // If no error was specified or it doesn't have a message property, drop straight down to using
    // the default message
    const errorMessage = error?.message;
    if (errorMessage) {
        if (errorMessage.includes($3a04d866c14d1333$export$83728ea2bd792f67.BULK_QUEUE_BUSY)) userMessage = (0, $hCblD.i18n).archiveErrorBulkQueueBusy;
        else if (errorMessage.includes($3a04d866c14d1333$export$83728ea2bd792f67.INVALID_CONTENT) || errorMessage.includes($3a04d866c14d1333$export$83728ea2bd792f67.MATCHING_PARENTPAGEID) || errorMessage.includes($3a04d866c14d1333$export$83728ea2bd792f67.INVALID_PARENTPAGEID)) userMessage = isArchive ? (0, $hCblD.i18n).ARCHIVE_archiveErrorInvalidContentIds : (0, $hCblD.i18n).UNARCHIVE_archiveErrorInvalidContentIds;
        else if (errorMessage.includes($3a04d866c14d1333$export$83728ea2bd792f67.INVALID_CONTENT_STATUS_ARCHIVED) || errorMessage.includes($3a04d866c14d1333$export$83728ea2bd792f67.ALREADY_ARCHIVED) || errorMessage.includes($3a04d866c14d1333$export$83728ea2bd792f67.ALREADY_UNARCHIVED_PAGES) || errorMessage.includes($3a04d866c14d1333$export$83728ea2bd792f67.INVALID_CONTENT_STATUS_DELETED) || errorMessage.includes($3a04d866c14d1333$export$83728ea2bd792f67.ALREADY_DELETED) || errorMessage.includes($3a04d866c14d1333$export$83728ea2bd792f67.INVALID_CONTENT_STATUS_DRAFT) || errorMessage.includes($3a04d866c14d1333$export$83728ea2bd792f67.IS_DRAFT)) userMessage = (0, $hCblD.i18n).archiveErrorInvalidContentStatusNotCurrent;
        else if (errorMessage.includes($3a04d866c14d1333$export$83728ea2bd792f67.PERMISSION_CONTENTID) || errorMessage.includes($3a04d866c14d1333$export$83728ea2bd792f67.NOT_AUTHORIZED_TO_ARCHIVE)) userMessage = (0, $hCblD.i18n).ARCHIVE_archiveErrorInvalidPermissions_Body;
        else if (errorMessage.includes($3a04d866c14d1333$export$83728ea2bd792f67.ITEMS_WITH_INVALID_UNARCHIVE_PERMISSIONS_SUBMITTED) || errorMessage.includes($3a04d866c14d1333$export$83728ea2bd792f67.NOT_AUTHORIZED_TO_UNARCHIVE_TO_PARENT)) userMessage = (0, $hCblD.i18n).UNARCHIVE_archiveErrorInvalidPermissions_Body;
        else if (errorMessage.includes($3a04d866c14d1333$export$83728ea2bd792f67.LONG_TASK_TIMEOUT)) userMessage = (0, $hCblD.i18n).archiveErrorLongTaskTimeout;
    }
    const defaultMessage = isArchive ? (0, $hCblD.i18n).ARCHIVE_archiveContentFlagFailure_Body : (0, $hCblD.i18n).UNARCHIVE_archiveContentFlagFailure_Body;
    // If it is not one of the known messages, use the default message instead
    return userMessage || defaultMessage;
};
const $3a04d866c14d1333$export$ea6c52e9f51ca365 = ({ isArchive: isArchive })=>{
    return {
        ...isArchive ? (0, $hCblD.archiveFlagI18n) : (0, $hCblD.unarchiveFlagI18n),
        getErrorMessage: (error)=>$3a04d866c14d1333$export$7a5564ff3f97fa60({
                error: error,
                isArchive: isArchive
            })
    };
};
module.exports["getArchiveFlagI18nWithErrorMsgs"] = $3a04d866c14d1333$export$ea6c52e9f51ca365;

});

parcelRegister("hCblD", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $f8eaa805df3b1851$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    // ---------- MESSAGE IN ALL ERROR FLAGS -------------
    tryLater: {
        id: "archive-pages.single-page.flag.failure.try-later",
        defaultMessage: "Try again later,"
    },
    archiveErrorBulkQueueBusy: {
        id: "archive-pages.archive.error.bulk-queue-busy",
        defaultMessage: "Your team is processing a large number of items. <b>Try again later</b>, after the queue has time to clear. {lineBreak} {lineBreak} If this continues to happen, try contacting {supportLink}."
    },
    archiveErrorInvalidContentStatusNotCurrent: {
        id: "archive-pages.archive.error.invalid-content-status",
        defaultMessage: "One or more of the items you have selected can not be archived because it has been deleted, is a draft, or already has been archived."
    },
    archiveErrorLongTaskTimeout: {
        id: "archive-pages.archive.error.long-task-timeout",
        defaultMessage: "Your request is taking longer than expected to process. Please check back soon to see if it completed successfully."
    },
    // ---------- ARCHIVE FLAGS -------------
    ARCHIVE_archiveContentFlagSuccess_Title: {
        id: "archive-pages.single-content.archive.flag.success.title",
        defaultMessage: "Archived successfully"
    },
    ARCHIVE_archiveContentFlagSuccess_LinkText: {
        id: "archive-pages.single-content.archive.flag.success.link-text",
        defaultMessage: "View in archive"
    },
    ARCHIVE_archiveContentFlagFailure_Title: {
        id: "archive-pages.single-content.archive.flag.failure.title",
        defaultMessage: "Your archive request had a problem"
    },
    ARCHIVE_archiveContentFlagFailure_Body: {
        id: "archive-pages.single-content.archive.flag.failure.body",
        defaultMessage: "Your team is processing a large number of items. {tryLater} after the queue has time to clear. {lineBreak} {lineBreak} If this continues to happen, try contacting {supportLink}."
    },
    ARCHIVE_archiveContentFlagProgress_Title: {
        id: "archive-pages.single-content.archive.flag.progress.title",
        defaultMessage: "Archiving..."
    },
    ARCHIVE_archiveErrorInvalidPermissions_Body: {
        id: "archive-pages.archive.error.invalid-perimissions.body",
        defaultMessage: "Your archive request has items that you don\u2019t have permission to archive. Please check your selections and try archiving again."
    },
    ARCHIVE_archiveErrorInvalidContentIds: {
        id: "archive-pages.archive.error.invalid-content-ids",
        defaultMessage: "Your archive request contains items that don\u2019t seem to exist. Please check your selections and try archiving again. {lineBreak} {lineBreak} If this continues to happen, try contacting {supportLink}."
    },
    // ---------- UNARCHIVE FLAGS -------------
    UNARCHIVE_archiveContentFlagSuccess_Title: {
        id: "archive-pages.single-content.unarchive.flag.success.title",
        defaultMessage: "Restored successfully"
    },
    UNARCHIVE_archiveContentFlagSuccess_LinkText: {
        id: "archive-pages.single-content.unarchive.flag.success.link-text",
        defaultMessage: "View"
    },
    UNARCHIVE_archiveContentFlagFailure_Title: {
        id: "archive-pages.single-content.unarchive.flag.failure.title",
        defaultMessage: "Your restore request had a problem"
    },
    UNARCHIVE_archiveContentFlagFailure_Body: {
        id: "archive-pages.single-content.unarchive.flag.failure.body",
        defaultMessage: "Your team is processing a large number of items. {tryLater} after the queue has time to clear. {lineBreak} {lineBreak} If this continues to happen, try contacting {supportLink}."
    },
    UNARCHIVE_archiveContentFlagProgress_Title: {
        id: "archive-pages.single-content.unarchive.flag.progress.title",
        defaultMessage: "Restoring..."
    },
    UNARCHIVE_archiveErrorInvalidPermissions_Body: {
        id: "archive-pages.unarchive.error.invalid-perimissions.body",
        defaultMessage: "Your restore request has items that you don\u2019t have permission to restore. Please check your selections and try the restore again."
    },
    UNARCHIVE_archiveErrorInvalidContentIds: {
        id: "archive-pages.unarchive.error.invalid-content-ids",
        defaultMessage: "Your restore request contains items that don\u2019t seem to exist. Please check your selections and try restoring again. {lineBreak} {lineBreak} If this continues to happen, try contacting {supportLink}."
    },
    refresh_LinkText: {
        id: "archive-pages.bulk-archive.flag.refresh.link-text",
        defaultMessage: "Refresh"
    }
});
const $f8eaa805df3b1851$export$e52c1807fd5a2355 = {
    successTitle: $f8eaa805df3b1851$export$a7357cdd1f0b0168.ARCHIVE_archiveContentFlagSuccess_Title,
    successLink: $f8eaa805df3b1851$export$a7357cdd1f0b0168.ARCHIVE_archiveContentFlagSuccess_LinkText,
    errorTitle: $f8eaa805df3b1851$export$a7357cdd1f0b0168.ARCHIVE_archiveContentFlagFailure_Title,
    loadingTitle: $f8eaa805df3b1851$export$a7357cdd1f0b0168.ARCHIVE_archiveContentFlagProgress_Title
};
const $f8eaa805df3b1851$export$98cae440262981f5 = {
    successTitle: $f8eaa805df3b1851$export$a7357cdd1f0b0168.UNARCHIVE_archiveContentFlagSuccess_Title,
    successLink: $f8eaa805df3b1851$export$a7357cdd1f0b0168.UNARCHIVE_archiveContentFlagSuccess_LinkText,
    errorTitle: $f8eaa805df3b1851$export$a7357cdd1f0b0168.UNARCHIVE_archiveContentFlagFailure_Title,
    loadingTitle: $f8eaa805df3b1851$export$a7357cdd1f0b0168.UNARCHIVE_archiveContentFlagProgress_Title
};
module.exports["i18n"] = $f8eaa805df3b1851$export$a7357cdd1f0b0168;
module.exports["archiveFlagI18n"] = $f8eaa805df3b1851$export$e52c1807fd5a2355;
module.exports["unarchiveFlagI18n"] = $f8eaa805df3b1851$export$98cae440262981f5;

});


//# sourceMappingURL=UnarchivePagesLoader.c697ddb3.js.map
